// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:46:13+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            fbc294e4fe6eca313852577fffe919b8
//    Signature:      eyJpdiI6ImVESFRJdFFRY2hoN2NPMHZ2K09WVGc9PSIsInZhbHVlIjoiXC9aTWc4OHlmTjZzR0JiNUQ5MFJ4ZkJyZkpKWHFWVjdNWTFLeDlCNVJxVGNtbWhrd1pCY2xhNFVPMkJMcnIwUFpHXC9cL1RpY3krbFRTN2JcL29oU1ZYdTZkc25tQTAwQzVJVDZ1Z0szTXJEd0FmeGszdjNGNFlMZW9Za29ucStxMHRlWFNPSXllVjBieXhTMGgxZXVyeTdFXC94R2U0UW93VytqTis4T2FYc2VQam9qdFcwTnNsRHdOeUhrYzZRRjVaWHBKQ0tcL0RUS0lUUU9XQTA5NWNKTlVKMldKaEgwcnNXRlRiMmp5TkkybXVncmNvc3MwcDRsNUk1XC9kSmc1bktPU1llXC9ZODR1Vm1KQURqeVhlcGlOSUJVSzZ6RU43YmlMUkxScGxTRG5LSGN0SmdBVjlYMWp4N2ZzZGQwMmd5OVkzU2ZoQ1pRWW9VUU44RmZJXC84Tm1yNVNRRGVmQzBBRXp0bFdIXC9yR2hqYXpMOVNIbTJGY2VwZWlNV0RyM3MrNDRvM2lcLzVBNTFYTUllOHBPVWhpdUsxcXZnPT0iLCJtYWMiOiJjMWMxNWVjZWUwMzY1YmQyMzAxMzYxMjQ5N2FhZTVkNTVlMjcxMGU3MDc3NGRiZmY1OWI2NGIzNjQ0Mzc1MzM1In0=

  customElements.define('currency-select', class CurrencySelect extends HTMLElement {
      constructor() {
        super();

        this.currencies = this.querySelectorAll('.set-currency');
        this._self = this;

        this.currencies.forEach(el => el.addEventListener('click', event => {
          event.preventDefault();
      
          if (!event.target.classList.contains('selected')) {
              const sel = this._self.querySelector('#currency');
      
              var opts = sel.options;
              for (var opt, j = 0; opt = opts[j]; j++) {
                  if (opt.value == el.dataset.currency) {
                    sel.selectedIndex = j;
                    sel.parentElement.submit();
                    break;
                  }
              }
          }

          return;
        }));
      }
  }) 
